import Empty from './Empty';
import './style/index.less';
export default Empty;